export default __webpack_public_path__ + "static/media/undraw_city_driver_re_0x5e.a63ec7fe.svg";